import Globals from "./utils";
export function logOutRedirectCall() {
    console.log("inside logout redirect");
    localStorage.clear();

    // Redirect to base URL
    const baseUrl = Globals.APP_BASE_URL || "/";
    window.location.replace(baseUrl);
}